import { BoardBasisCode } from '@libs/trip-planner-interfaces';

import type { PossibleMealFilters } from '../../model/hotelFilters';
import { HotelFilter } from '../../model/hotelFilters';

export function getMealTypeForFilter(
  code: BoardBasisCode
): PossibleMealFilters {
  switch (code) {
    case BoardBasisCode.RO:
      return HotelFilter.MealsNoMeals;
    case BoardBasisCode.BB:
      return HotelFilter.MealsBreakfast;
    case BoardBasisCode.HB:
      return HotelFilter.MealsHalfBoard;
    case BoardBasisCode['HB+']:
      return HotelFilter.MealsHalfBoard;
    case BoardBasisCode.FB:
      return HotelFilter.MealsFullBoard;
    case BoardBasisCode.AI:
      return HotelFilter.MealsAllInclusive;
  }
}
